import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMarker = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C16 5.23858 13.7614 3 11 3C8.23858 3 6 5.23858 6 8C6 9.72554 7.66063 13.0314 11 17.6531C14.3394 13.0314 16 9.72554 16 8ZM11 21C6.33333 14.9107 4 10.5773 4 8C4 4.13401 7.13401 1 11 1C14.866 1 18 4.13401 18 8C18 10.5773 15.6667 14.9107 11 21ZM11 9C11.5523 9 12 8.55228 12 8C12 7.44772 11.5523 7 11 7C10.4477 7 10 7.44772 10 8C10 8.55228 10.4477 9 11 9ZM11 11C9.34315 11 8 9.65685 8 8C8 6.34315 9.34315 5 11 5C12.6569 5 14 6.34315 14 8C14 9.65685 12.6569 11 11 11Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMarker);

export default ForwardRef;
